<template>
  <div class="footer-wrapper">
    <div class="footer-main">
      <!-- 左侧：联系方式 -->
      <div class="footer-contact">
        <h3 class="footer-title">联系我们</h3>
        <ul class="contact-list">
          <li><i class="el-icon-location"></i> 河南省郑州市二七区航海中路58-19号海为商务广场6楼606室</li>
          <li><i class="el-icon-phone"></i> 市场开发：18838101158</li>
          <li><i class="el-icon-chat-dot-round"></i> 问题投诉：18595800500</li>
          <li><i class="el-icon-message"></i> 企业邮箱：yibocanyin@sina.com</li>
        </ul>
      </div>

      <!-- 中间预留二维码区域（美化占位） -->
      <!-- <div class="footer-qrcode">
        <div class="qrcode-placeholder">
          <div class="qrcode-icon">📱</div>
          <p>官方微信</p>
          <span>扫码关注</span>
        </div>
      </div> -->

      <!-- 右侧：多列导航 -->
      <div class="footer-nav">
        <div class="nav-col">
          <h4 class="nav-title">走进翼博</h4>
          <ul>
            <li><router-link to="/honor/myzs1">企业简介</router-link></li>
            <li><router-link to="/honor/myzs2">企业文化</router-link></li>
            <li><router-link to="/honor/myzs3">组织架构</router-link></li>
            <li><router-link to="/honor/myzs4">企业资质</router-link></li>
            <li><router-link to="/honor/myzs7">企业体系认证</router-link></li>
            <li><router-link to="/honor/myzs8">企业信用认证</router-link></li>
            <li><router-link to="/honor/myzs5">荣誉证书</router-link></li>
          </ul>
        </div>
        <div class="nav-col">
          <h4 class="nav-title">菜品展示</h4>
          <ul>
            <li><router-link to="/cp/mycp1">荤菜</router-link></li>
            <li><router-link to="/cp/mycp5">半荤菜</router-link></li>
            <li><router-link to="/cp/mycp2">素菜</router-link></li>
            <li><router-link to="/cp/mycp3">主食甜点</router-link></li>
            <li><router-link to="/cp/mycp4">精品小吃</router-link></li>
          </ul>
        </div>
        <div class="nav-col">
          <h4 class="nav-title">酒店餐饮</h4>
          <ul>
            <li><router-link to="/business">商务餐</router-link></li>
            <li><router-link to="/buffet">自助餐</router-link></li>
          </ul>
        </div>
        <div class="nav-col">
          <h4 class="nav-title">团队建设</h4>
          <ul>
            <li><router-link to="/team/Introduction">团队简介</router-link></li>
            <li><router-link to="/team/Activity">团建活动</router-link></li>
            <li><router-link to="/team/Training">团队培训</router-link></li>
          </ul>
        </div>
        <div class="nav-col">
          <h4 class="nav-title">管理体系</h4>
          <ul>
            <li><router-link to="/sixs">6S管理</router-link></li>
            <li><router-link to="/safe">安全管理</router-link></li>
            <li><router-link to="/system">制度规范</router-link></li>
            <li><router-link to="/pdca">PDCA循环</router-link></li>
            <li><router-link to="/nutrition">营养管理</router-link></li>
            <li><router-link to="/informatization">信息化支撑</router-link></li>
          </ul>
        </div>
        <div class="nav-col">
          <h4 class="nav-title">快速链接</h4>
          <ul>
            <li><router-link to="/model">典型案例</router-link></li>
            <li><router-link to="/honor/myzs6">新闻动态</router-link></li>
            <li><a href="https://yibocanyin.com:9001" target="_blank">内网登录</a></li>
            <li><router-link to="/login">后台登录</router-link></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="footer-copyright">
      <div class="copyright-content">
        <span>豫ICP备2023010810号</span>
        <span>Copyright © 翼博公司 版权所有 All Rights Reserved</span>
      </div>
    </div>

    <!-- 返回顶部按钮 -->
    <transition name="fade">
      <button v-if="button_show" class="back-to-top" @click="toTop">
        <i class="el-icon-upload2"></i>
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      button_show: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      this.button_show = window.pageYOffset > 300;
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.footer-wrapper {
  background: linear-gradient(135deg, #003d66 0%, #002b4a 100%);
  color: #e0e0e0;
  font-family: 'Segoe UI', 'PingFang SC', Roboto, Helvetica, Arial, sans-serif;
}

.footer-main {
  max-width: 80%;
  margin: 0 auto;
  padding: 48px 24px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
}

/* 左侧联系方式 */
.footer-contact {
  flex: 1.2;
  min-width: 240px;
}
.footer-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #fff;
  position: relative;
  display: inline-block;
  letter-spacing: 1px;
  width: 100%;
  text-align: left;
}
.footer-title:after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 40px;
  height: 2px;
  background: #facc15;
}
.contact-list {
  list-style: none;
  margin-top: 12px;
}
.contact-list li {
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.contact-list i {
  margin-top: 2px;
  font-size: 16px;
  color: #facc15;
  flex-shrink: 0;
}

/* 中间二维码区域 */
.footer-qrcode {
  flex: 0.5;
  min-width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.qrcode-placeholder {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  border-radius: 16px;
  padding: 16px 20px;
  text-align: center;
  width: 140px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.2s;
}
.qrcode-placeholder:hover {
  transform: scale(1.02);
  background: rgba(255, 255, 255, 0.15);
}
.qrcode-icon {
  font-size: 48px;
  margin-bottom: 8px;
}
.qrcode-placeholder p {
  font-size: 16px;
  font-weight: 500;
  margin: 8px 0 4px;
  color: #fff;
}
.qrcode-placeholder span {
  font-size: 12px;
  color: #facc15;
}

/* 右侧导航 */
.footer-nav {
  flex: 3;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}
.nav-col h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #fff;
  border-left: 3px solid #facc15;
  /* padding-left: 10px; */
}
.nav-col ul {
  list-style: none;
}
.nav-col li {
  margin-bottom: 10px;
}
.nav-col a {
  color: #d1d5db;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.2s, padding-left 0.2s;
  display: inline-block;
}
.nav-col a:hover {
  color: #facc15;
  padding-left: 4px;
}

/* 版权栏 */
.footer-copyright {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding: 20px 24px;
  text-align: center;
}
.copyright-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 12px;
  color: #aaa;
}
.copyright-content span {
  letter-spacing: 0.5px;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #facc15;
  border: none;
  color: #002b4a;
  font-size: 22px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.back-to-top:hover {
  background: #ffc107;
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 响应式适配 */
@media (max-width: 992px) {
  .footer-main {
    flex-direction: column;
    gap: 32px;
  }
  .footer-contact, .footer-qrcode, .footer-nav {
    width: 100%;
  }
  .footer-nav {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
  .copyright-content {
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }
}

@media (max-width: 640px) {
  .footer-main {
    padding: 32px 20px;
  }
  .footer-nav {
    gap: 24px;
  }
  .nav-col h4 {
    font-size: 15px;
  }
}
</style>